import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {Chart} from "react-google-charts";
import React from "react";

export const TreeMapCardComponent = (props) => {
    return (
        <div className="ibox">
            <div className="ibox-title">
                <h4>{props.title}</h4>
                <small className={"d-block"}>{props.subtitle}</small>
            </div>
            <div className="ibox-content">
                <div className={"card-body text-center"}>
                    {
                        props.data.length > 2
                            ? <Chart
                                height={props.height}
                                chartType={"TreeMap"}
                                loader={<div className='h-100 d-flex align-items-center justify-content-center'>
                                    <CircularProgress/>
                                </div>}
                                data={props.data}
                                options={{
                                    highlightOnMouseOver: true,
                                    maxDepth: 1,
                                    maxPostDepth: 2,
                                    minColor: '#a8eb12',
                                    midColor: '#008793',
                                    maxColor: '#051937',
                                    minHighlightColor: '#5ffbf1',
                                    midHighlightColor: '#79b3f4',
                                    maxHighlightColor: '#8c6bb1',
                                    headerHeight: 25,
                                    headerColor: '#008793',
                                    showScale: true,
                                    fontColor: 'white',
                                    height: 500,
                                    useWeightedAverageForAggregation: true,
                                    generateTooltip: (row, size, value) => {
                                        return (
                                            "<div class='card'>" +
                                            "<div class='card-body'>" +
                                            "Drugs: " +
                                            size +
                                            "</div>" +
                                            "</div>"
                                        )
                                    }
                                }}
                            />
                            : <div style={{minHeight: props.height}}>
                                <h3>No data available</h3>
                            </div>
                    }
                </div>
            </div>
        </div>


    )
}
